import { init } from '@airwallex/components-sdk';

/**
 * Airwallex SDK Client Plugin
 * Initializes Airwallex SDK once when the application starts
 * This plugin runs only on the client side (browser)
 */
let isInitialized = false;

export default async ({ app }) => {
  // Only run on client side
  if (process.server) {
    return;
  }

  // Initialize Airwallex SDK only once
  if (!isInitialized) {
    try {
      console.log('[Airwallex Plugin] Initializing Airwallex SDK...');

      await init({
        env: 'prod', // Can choose other production environments: 'staging' | 'demo' | 'prod'
        origin: window.location.origin, // Setup your event target to receive the browser events message
      });

      isInitialized = true;
      console.log('[Airwallex Plugin] Airwallex SDK initialized successfully');

      // Make the init status available to the app
      app.$airwallexInitialized = true;
      // Also attach to window for direct access
      // eslint-disable-next-line no-underscore-dangle
      window.__airwallexInitialized = true;
    } catch (error) {
      console.error('[Airwallex Plugin] Failed to initialize Airwallex SDK:', error);
      app.$airwallexInitialized = false;
      // eslint-disable-next-line no-underscore-dangle
      window.__airwallexInitialized = false;
    }
  } else {
    console.log('[Airwallex Plugin] Airwallex SDK already initialized');
  }
};
